// Initialize Swiper
// document.addEventListener("DOMContentLoaded", () => {
// initSwipers();
// });

// document.addEventListener("shopify:section:load", () => {
// initSwipers();
// });

// function initSwipers() {
//     document.querySelectorAll('[data-swiper]').forEach((slider) => {

//         // Prevent double init
//         if (slider.classList.contains('swiper-initialized')) return;

//         const nextBtn = slider.querySelector('[data-swiper-next]');
//         const prevBtn = slider.querySelector('[data-swiper-prev]');

//         new Swiper(slider, {
//         slidesPerView: 4,
//         spaceBetween: 20,
//         navigation: {
//             nextEl: nextBtn,
//             prevEl: prevBtn,
//         },
//         breakpoints: {
//             0: {
//             slidesPerView: 1.2,
//             },
//             750: {
//             slidesPerView: 2,
//             },
//             990: {
//             slidesPerView: 4,
//             },
//         }
//         });
//     });
// }



// collapsible-content-with-images.liquid accordian and image
(function () {
  function showImage(section, blockId = null) {
    const imageContainer = section.querySelector('[id^="accordion-image-container-"]');
    if (!imageContainer) return;

    const allImages = imageContainer.querySelectorAll('.accordion-image');

    // Hide all images
    allImages.forEach((img) => {
      img.style.opacity = '0';
      img.style.pointerEvents = 'none';
    });

    let imageToShow = null;

    if (blockId) {
      imageToShow = imageContainer.querySelector(
        `.accordion-image[data-block-id="${blockId}"]`
      );
    }

    if (!imageToShow) {
      imageToShow = imageContainer.querySelector('.accordion-image:not(.default-image)')
        || imageContainer.querySelector('.default-image');
    }

    if (imageToShow) {
      imageToShow.style.opacity = '1';
      imageToShow.style.pointerEvents = 'auto';
    }
  }

  function initAccordionImageSync(section) {
    const accordionDetails = section.querySelectorAll('details[data-block-id]');
    if (!accordionDetails.length) return;

    // 👉 INITIAL IMAGE SYNC ON LOAD
    const openAccordion = Array.from(accordionDetails).find(d => d.open);
    showImage(section, openAccordion?.getAttribute('data-block-id'));

    accordionDetails.forEach((details) => {
      details.addEventListener('toggle', function () {
        if (!this.open) return;

        const blockId = this.getAttribute('data-block-id');
        showImage(section, blockId);

        // Close others
        accordionDetails.forEach((other) => {
          if (other !== details && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  function initAllAccordionImageSections() {
    document
      .querySelectorAll('[data-accordion-image-section]')
      .forEach(initAccordionImageSync);
  }

  document.addEventListener('DOMContentLoaded', initAllAccordionImageSections);

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-accordion-image-section]');
    if (section) initAccordionImageSync(section);
  });
})();